'use client'

/**
 * Loading Spinner
 *
 * Compact spinner for buttons and inline operations
 * Quiet luxury styling to match fintech aesthetic
 */

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  color?: 'current' | 'inherit' | 'white' | 'primary'
}

export function LoadingSpinner({
  size = 'sm',
  className = '',
  color = 'current',
}: LoadingSpinnerProps) {
  const sizeClass = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }[size]

  const colorClass = {
    current: 'text-current',
    inherit: 'text-inherit',
    white: 'text-white',
    primary: 'text-[#1a1818]',
  }[color]

  return (
    <svg
      className={`${sizeClass} ${colorClass} ${className} animate-spin`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}
